'use client'

import { motion } from 'framer-motion'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'
import Countdown from 'react-countdown'
import Cookies from 'js-cookie'

import ActiveSuccessful from '@/assets/svg/checkmark.svg'
import { appSelectors, useAppStore } from '@/store'

interface SuccessPinVerificationProps {
  token?: string
}

export const SuccessPinVerification: React.FC<
  SuccessPinVerificationProps
> = () => {
  const t = useTranslations('auth.pinVerification')
  const router = useRouter()
  const { setUserVerifyEmail } = useAppStore(appSelectors.actions)

  const renderRedirectTimer = useCallback(
    ({ seconds, completed }: { seconds: number; completed: boolean }) => {
      if (completed) {
        setUserVerifyEmail(undefined)
        const token = Cookies.get('access_token')
        if (token) {
          router.replace('/')
        }
        return
      } else {
        return <span>{seconds.toString()}</span>
      }
    },
    [router, setUserVerifyEmail],
  )

  const countDownDate = useMemo(() => new Date().getTime() + 3000, [])

  return (
    <motion.div
      initial={{ opacity: 0, y: '100% ' }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1, y: 0 }}
      style={{
        display: 'flex',
        height: '100%',
        minHeight: '500px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        justifyContent: 'center',
      }}
      className="text-white"
    >
      <Image
        src={ActiveSuccessful}
        alt="activation successful"
        width={150}
        priority
      />

      <h3>{t('success.verificationSuccessful')}</h3>
      <p>
        {t('signingIn')}{' '}
        <strong>
          <Countdown renderer={renderRedirectTimer} date={countDownDate} />
        </strong>
      </p>
    </motion.div>
  )
}
